import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';
import {User} from '../resources/User';

/**
 * This event can be fired to indicate that some data as requested via the
 * {@see UserExportRequested} event is available and can be processed.
 */
export class UserExportAvailable extends EntityExportAvailableEvent<User> {}
